import {
  FragmentViewNavigationState,
  routeGenerator,
} from '@app/modules/fragments/routing/FragmentsRoutes';
import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';

/**
 * Builds the navigation target used by fragment cards so route and route state
 * stay consistent across all card variants.
 */
export function buildFragmentNavigationParams(fragment: FragmentListItemDto) {
  return {
    pathname: routeGenerator.view(fragment.id),
    state: { fragment } satisfies FragmentViewNavigationState,
  };
}
